import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "w-chat-panel" }

import PersonalChat from "@/components/widget/ui/personalChat.vue";
import {nextTick, onMounted, ref, watch} from "vue";

interface IChatMessage {
  messages: IChatMessage[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'WidgetChatPanel',
  props: {
    messages: {}
  },
  setup(__props: any) {

const props = __props;

const listRef = ref<HTMLElement | null>(null)
const itemRefs = ref<HTMLElement[]>([]);

const setItemRef = (el: Element | null, index: number) => {
  if (el) {
    itemRefs.value[index] = el as HTMLElement;
  }
};

const scrollToBottom = async () => {
  await nextTick()

  if (listRef.value) {
    listRef.value.scrollTop = listRef.value.scrollHeight
  }
}

onMounted(() => {
  scrollToBottom()
})

watch(
    () => props.messages?.length,
    () => {
      scrollToBottom()
    }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "list",
      ref_key: "listRef",
      ref: listRef
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...__props.messages].reverse(), (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          ref_for: true,
          ref: (el) => setItemRef(el, index),
          key: item.id,
          class: _normalizeClass(["list__item", item.is_outgoing])
        }, [
          _createVNode(PersonalChat, { item: item }, null, 8, ["item"])
        ], 2))
      }), 128))
    ], 512)
  ]))
}
}

})